/** 与信息登记列表、小程序展示目录共用的公众号草稿状态展示 */

export function draftLabel(s: string | null | undefined): string {
  const m: Record<string, string> = {
    pending: '待处理',
    success: '草稿已添加',
    failed: '草稿失败',
    skipped: '跳过草稿',
    awaiting_review: '待人工审核',
    review_rejected: '审核已拒绝',
  };
  const k = (s ?? '').trim();
  return m[k] || k || '未知';
}

/**
 * 列表「公众号草稿」列：区分是否已写入微信草稿箱。
 * 若 `draft_status` 异常为空但已有 `wechat_draft_media_id`，按已进草稿箱展示（兼容历史脏数据）。
 */
export function draftWechatSummary(
  status: string | null | undefined,
  opts?: { wechatDraftMediaId?: string | null; entrySource?: string | null }
): { main: string; sub?: string; warn: boolean } {
  const st = (status ?? '').trim();
  const src = (opts?.entrySource ?? '').trim();
  const mid = (opts?.wechatDraftMediaId ?? '').trim();
  const inferSuccessFromMedia = mid !== '' && (st === '' || st === 'pending');

  if (src === 'mp_user') {
    if (st === 'awaiting_review') {
      return { main: '小程序待审', sub: '用户自助投稿', warn: true };
    }
    if (st === 'review_rejected') {
      return { main: '已拒绝', sub: '不在小程序展示', warn: true };
    }
    if (st === 'skipped' || st === 'success' || st === 'pending' || st === 'failed') {
      return { main: '小程序已展示', warn: false };
    }
  }

  if (st === 'success' || inferSuccessFromMedia) {
    return { main: '已进草稿箱', sub: inferSuccessFromMedia ? '已写入微信（media_id 在库）' : undefined, warn: false };
  }
  if (st === 'failed') {
    return { main: '未进草稿箱', sub: '草稿失败', warn: true };
  }
  if (st === 'skipped') {
    return { main: '未进草稿箱', sub: '未写入（已跳过）', warn: true };
  }
  if (st === 'awaiting_review') {
    return { main: '未进草稿箱', sub: '待人工审核后再推', warn: true };
  }
  if (st === 'review_rejected') {
    return { main: '未进草稿箱', sub: '审核已拒绝', warn: true };
  }
  return { main: '未进草稿箱', sub: '待上传', warn: true };
}
